/**
 * Custom event shortcuts.
 */
import { Events } from "../../features/analytics/events";

export class EventTracker {
  constructor(public readonly client: Events) {}

  /** Capture one of your own events by name — see {@link Events.capture}. */
  capture(name: string, properties?: Record<string, unknown>) {
    return this.client.capture(name, properties);
  }

  /** Track a custom event. */
  track(eventName: string, properties?: Record<string, unknown>, opts?: { userId?: string; sessionId?: string }) {
    return this.client.track({ eventName, properties, userId: opts?.userId, sessionId: opts?.sessionId });
  }

  /** Track many events in one request. */
  batch(events: Array<{ eventName: string; properties?: Record<string, unknown> }>) {
    return this.client.trackBatch({ events });
  }

  /** Track a click on a tagged element. */
  click(elementId: string, elementText: string, properties?: Record<string, unknown>) {
    return this.client.trackClick({ elementId, elementText, properties });
  }

  /** Track a form interaction. */
  form(formId: string, formName: string, properties?: Record<string, unknown>) {
    return this.client.trackForm({ formId, formName, properties });
  }

  /** Track a search query. */
  search(query: string, category: string, properties?: Record<string, unknown>) {
    return this.client.trackSearch({ query, category, properties });
  }

  /** Track a runtime error. */
  error(message: string, type: string, properties?: Record<string, unknown>) {
    return this.client.trackError({ message, type, properties });
  }
}
